var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentsFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "documents-folder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.916,
    height: 29.2,
    viewBox: "0 0 28.916 29.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M112.77-511.863a1.143,1.143,0,0,0-.65.662c-.114.251-.12.354-.12,4.06v3.81h2.053v-6.729h13.972v9.467h1.939l-.011-5.264c-.017-4.768-.029-5.275-.114-5.429a1.466,1.466,0,0,0-.644-.6c-.217-.1-.587-.108-8.184-.108h-7.956Z",
    transform: "translate(-105.754 512)",
    fill: "#fffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M182.6-439.92a1.128,1.128,0,0,0-.6.958,1.13,1.13,0,0,0,.644.952c.108.046,1.534.063,4.391.063,4.066,0,4.237-.006,4.408-.108a1.405,1.405,0,0,0,.342-.325.743.743,0,0,0,.165-.593.743.743,0,0,0-.165-.593,1.406,1.406,0,0,0-.342-.325c-.171-.1-.342-.108-4.425-.108A38.756,38.756,0,0,0,182.6-439.92Z",
    transform: "translate(-171.762 444.106)",
    fill: "#fffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M183.925-372.678c-.416.125-.867.855-.525.855a4.171,4.171,0,0,1,1.391.827l.4.371h3.581c3.359,0,3.6-.011,3.815-.108a.87.87,0,0,0,.513-.536,1.065,1.065,0,0,0-.388-1.283l-.234-.154-4.192-.011C185.978-372.724,184.016-372.707,183.925-372.678Z",
    transform: "translate(-172.969 380.662)",
    fill: "#fffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M4.754-335.725A1.554,1.554,0,0,0,3.7-334.493a2.04,2.04,0,0,0,.029.9c.057.325.1.616.1.65s-.125.08-.279.1a1.234,1.234,0,0,0-1.061,1.038c-.051.348,2.042,13.864,2.2,14.206a2.029,2.029,0,0,0,.394.5c.53.479-.5.439,11.8.439H27.806l.291-.137a1.176,1.176,0,0,0,.707-1.123c0-.428-1.985-13.841-2.093-14.138a1.28,1.28,0,0,0-.741-.73c-.171-.051-1.517-.068-5.423-.068h-5.2l-.61-.724c-1.392-1.642-1.717-1.962-2.173-2.133a30.8,30.8,0,0,0-3.861-.091C5.308-335.828,5.028-335.816,4.754-335.725Z",
    transform: "translate(-2.484 345.865)",
    fill: "#fffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M449-318.954c0,.029.114,1.112.257,2.418.154,1.426.5,3.975.855,6.41.331,2.224.6,4.066.6,4.095,0,.279.171-.8.912-5.84.576-3.935.85-5.92.827-6.079a1.216,1.216,0,0,0-.673-.907c-.285-.137-.342-.143-1.534-.143A8.955,8.955,0,0,0,449-318.954Z",
    transform: "translate(-423.535 330.007)",
    fill: "#fffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsFolder);
export default __webpack_public_path__ + "static/media/documents-folder.24eff725f8ccfafbb36cedb04aa86ae4.svg";
export { ForwardRef as ReactComponent };